import { useEffect } from "react";
import { Button } from "@mui/material";
import { FallbackProps } from "react-error-boundary";
import { toast } from "react-toastify";
import { normalizeError, logError } from "@shared/lib/errors";
import { useAuth } from "@features/auth/contexts/AuthContext";

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const appError = normalizeError(error);
  const { logoutUser } = useAuth();
  const shouldLogout = appError.shouldLogout || appError.kind === "auth";

  useEffect(() => {
    if (!shouldLogout) {
      return;
    }

    logError(appError, "error-fallback");

    // No Router context above this boundary (it wraps the RouterProvider itself),
    // so a full navigation is used instead of useNavigate to reach /login.
    (async () => {
      await logoutUser();
      toast.error(
        <>
          נותקת עקב חוסר פעילות. <br />
          יש להתחבר מחדש.
        </>,
        { autoClose: 5000, toastId: "session-expired" }
      );
      window.location.href = "/login";
    })();
  }, [shouldLogout, appError, logoutUser]);

  if (shouldLogout) {
    return null;
  }

  return (
    <div role="alert" style={{ padding: "1rem" }}>
      <h2>אירעה שגיאה</h2>
      <p>{appError.userMessage}</p>
      {appError.retryable ? <Button onClick={resetErrorBoundary}>נסה שוב</Button> : null}
    </div>
  );
}

export default ErrorFallback;
